// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3JLLi","footer":"ModalInfo_footer__31Ihh"};